import { ApprovalDialog } from '@components/Forms';
import { useToast } from 'hooks';
import React from 'react';
import { AccessKeyStatus, IAccessKey } from 'types/accessKeys';
import { IDataResponse } from 'types/common';
import { IAccessKeyRowAction } from './types';

const AccessKeyStatusDialog: React.FC<
	IAccessKeyRowAction<
		IDataResponse<IAccessKey>,
		{
			key: string;
			status: AccessKeyStatus;
		}
	>
> = ({ onComplete, row, mutation, accessKeyType }) => {
	const { invokeToastableAction } = useToast();

	const key = row?.row as IAccessKey;
	const action =
		key.status === AccessKeyStatus.active ? 'deactivate' : 'activate';

	const handleUpdate = async () => {
		await invokeToastableAction(
			() =>
				mutation.mutateAsync({
					key: key.id,
					status: key.status
				}),
			`${accessKeyType}.action.${action}.dialog.toast`,
			onComplete
		);
	};

	return (
		<ApprovalDialog
			onApprove={handleUpdate}
			onCancel={onComplete}
			title={intl.tr(`${accessKeyType}.action.${action}.dialog.header`)}
			question={intl.tr(`${accessKeyType}.action.${action}.dialog.question`, {
				name: key.name || ''
			})}
			approveText={intl.tr(`button.${action}`)}
			cancelText={intl.tr('button.cancel')}
		/>
	);
};

export default AccessKeyStatusDialog;
